import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { iconCodes } from '@app/shared/cqes-icon/cqes-icon.component';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { BusinessService } from '../business.service';
import { selectorAuth, SessionStorageService } from '@app/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { IUserData } from '@app/profile/main/details';
import { Store } from '@ngrx/store';
import { BusinessWebIndentificationComponent } from './business-web-indentification/business-web-indentification.component';
import { BusinessIdentificationComponent } from './business-identification/business-identification.component';


@Component({
  selector: 'cloud-business-history',
  templateUrl: './business-history.component.html',
  styleUrls: ['./business-history.component.scss']
})
export class BusinessHistoryComponent implements OnInit, OnDestroy {

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  @ViewChild(BusinessWebIndentificationComponent)
  webIdentificationComponent!: BusinessWebIndentificationComponent;
  loaded = false;
  readonly icons = iconCodes;
  // hasSecondTabBeenSelected = false;
  unsubscribe$: Subject<void> = new Subject<void>();
  userData: IUserData;
  groups = [];
  businessAccountId: any;
  hasIdentification: boolean;
  hasWebIdentification: boolean;
  companyId: any;
  cmrId: any;
  selectedTabs: { [key: number]: boolean } = {};
  employeeId: any;
  // hasThirdTabBeenSelected = false;
  // hasIdentificationTabBeenSelected = false;
  showFirstTab = false;
  @ViewChild('requestedHistory')
  requestedHistory!: any;
  constructor(
    private businessService: BusinessService,
    private store: Store<any>,
    private sessionStorageService: SessionStorageService,
  ) { }

  ngOnInit(): void {
    this.store
      .select(selectorAuth)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res.userData) { this.userData = res.userData; }
        if (this.userData == undefined) {
          this.userData = this.sessionStorageService.getItem("loginEventData")
        }
      });
    this.businessAccountId = this.sessionStorageService.getItem("businessAccountId");
    this.getEmployeeId()
    this.getCompany()
    // BT-1494 conflict
    if (!this.showFirstTab) {
     this.loaded = true;
    }
    this.onTabChange({ index: 0 } as MatTabChangeEvent);
  }


  loadedData(e: boolean) {
    this.loaded = e;
    this.tabGroup.realignInkBar();
  }

  onTabChange(e: MatTabChangeEvent) {
    console.log('Selected tab index: ', e.index);
    this.selectedTabs[e.index] = true;

    if (e.index === 0 && this.requestedHistory) {
      this.requestedHistory.loadRequestedHistory();
    }
    if (e.index === 3) {
      if (this.webIdentificationComponent) {
        this.webIdentificationComponent.loadCertificates();
      }
    } else {
      if (this.webIdentificationComponent) {
        this.webIdentificationComponent.cancelLoading();
      }
    }
  }

  getCompany() {
    this.businessService.getCompany(this.businessAccountId).subscribe(res => {
      this.cmrId = this.userData.cmrId;
      this.companyId = res.data.id;
      this.getGroups()
    })
  }
  getEmployeeId() {
    this.employeeId = this.sessionStorageService.getItem("loginEventData")?.userData?.cmrId;
  }
  getGroups() {
    this.businessService.getEmployeesServices(this.businessAccountId, this.cmrId).subscribe(res => {
      this.groups = res.data;
      this.hasIdentification = this.getIdentification(this.groups, "IDENTIFICATION");
      this.hasWebIdentification = this.getIdentification(this.groups, "WEB_IDENTIFICATION");
    });
  }
  getIdentification(groups: any[], service: string): boolean {
    if (!groups || !Array.isArray(groups)) {
      return false;
    }

    return groups.some((group: any) => {
      return group.serviceType === service;
      //BT-1494 conflict
      //return group.serviceType === "IDENTIFICATION";
    });
  }


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
